import { type QueryHookOptions, useQuery } from '@apollo/react-hooks';
import { GET_REFEREE_FORM_INFO } from './GET_REFEREE_FORM_INFO.gql';
import { type ApplicantInformation } from '../../../components/ApplicationStatus/RefereeForm/types';

export const useQueryRefereeFormInfo = (
  options: QueryHookOptions,
): {
  data: { getRefereeFormInfo: ApplicantInformation };
  loading: boolean;
  error: any;
} => {
  // use a gql query to get referee form info
  const { data, loading, error } = useQuery(GET_REFEREE_FORM_INFO, options);
  return {
    data,
    loading,
    error,
  };
};
